import { lazy } from 'react';

import { type RoutePageMeta } from '../layouts/DashboardLayout/page-meta';

import type { RouteObject } from 'react-router-dom';

const DashboardPage = lazy(() =>
  import('@/domains/experience/dashboard/routes').then(m => ({ default: m.DashboardPage }))
);
const NotificationsPage = lazy(() =>
  import('@/domains/notifications/routes').then(m => ({ default: m.NotificationsPage }))
);
const NotificationPreferencesPage = lazy(() =>
  import('@/domains/notifications/routes').then(m => ({
    default: m.NotificationPreferencesPage,
  }))
);
const NotificationDetailPage = lazy(() =>
  import('@/domains/notifications/routes').then(m => ({ default: m.NotificationDetailPage }))
);
const SettingsPage = lazy(() =>
  import('@/domains/experience/settings/routes').then(m => ({ default: m.SettingsPage }))
);

// Page titles + breadcrumbs ride on each route's `handle` so PageTitleArea
// can resolve them via `useMatches` (plan 06 L3).
// Dashboard intentionally has a title for the header chrome even though it
// renders its own in-page greeting.
export function experienceRoutes(): RouteObject[] {
  return [
    {
      path: '/dashboard',
      element: <DashboardPage />,
      handle: { titleKey: 'navigation.home', namespace: 'common' } satisfies RoutePageMeta,
    },
    {
      path: '/notifications',
      element: <NotificationsPage />,
      handle: {
        titleKey: 'title',
        namespace: 'notifications',
      } satisfies RoutePageMeta,
    },
    {
      path: '/notifications/preferences',
      element: <NotificationPreferencesPage />,
      handle: {
        titleKey: 'preferences.title',
        namespace: 'notifications',
        breadcrumbs: [
          {
            labelKey: 'title',
            namespace: 'notifications',
            href: '/notifications',
          },
        ],
      } satisfies RoutePageMeta,
    },
    {
      path: '/notifications/:id',
      element: <NotificationDetailPage />,
      handle: {
        titleKey: 'detail.title',
        namespace: 'common',
        breadcrumbs: [
          {
            labelKey: 'title',
            namespace: 'notifications',
            href: '/notifications',
          },
        ],
      } satisfies RoutePageMeta,
    },
    {
      path: '/settings',
      element: <SettingsPage />,
      handle: { titleKey: 'navigation.settings', namespace: 'common' } satisfies RoutePageMeta,
    },
  ];
}
